import { enUSMessages } from "./en-US"

type MessageId = keyof typeof enUSMessages

export const frFRMessages: Record<MessageId, string> = {
  ...enUSMessages,
  "settings.language.option.fr-FR": "Français",
}
